var exports = {
  "N": "xcc377c0b--3a69a1--element",
  "V": "xcc377c0b--3a69a1--underline",
};

module.exports = exports;
